var Emoji = /* @__PURE__ */ (function () {
    function Emoji() {
        this.utf16patt = /[\ud800-\udbff][\udc00-\udfff]/g;
        this.entitiespatt = /&#\d+;/g;
    }
    Emoji.prototype.utf16toEntities = function (str) {
        var patt = this.utf16patt;
        str = str.replace(patt, function (char) {
            var H;
            var L;
            var code;
            var s;
            if (char.length === 2) {
                H = char.charCodeAt(0); // 取出高位
                L = char.charCodeAt(1); // 取出低位
                code = (H - 0xd800) * 0x400 + 0x10000 + L - 0xdc00; // 转换算法
                s = "&#".concat(code, ";");
            }
            else {
                s = char;
            }
            return s;
        });
        return str;
    };
    Emoji.prototype.entitiestoUtf16 = function (str) {
        if (!str) {
            return '';
        }
        var patt = this.entitiespatt;
        var arr = str.match(patt) || [];
        var H;
        var L;
        var code;
        for (var i = 0; i < arr.length; i += 1) {
            code = arr[i];
            code = code.replace('&#', '').replace(';', '');
            // 高位
            H = Math.floor((+code - 0x10000) / 0x400) + 0xd800;
            // 低位
            L = ((+code - 0x10000) % 0x400) + 0xdc00;
            code = "&#".concat(code, ";");
            var s = String.fromCharCode(H, L);
            str = str.replace(code, s);
        }
        return str;
    };
    return Emoji;
}());
export { Emoji };
